import { type ProviderAuthenticationIntentResponse } from '@unipile/types';
import { Button, ClassicWizard, CancelButton, Spinner, useStartProviderAuthIntent, type WizardComponent } from '@unipile/ui';

export const Wizard: WizardComponent = ({ onSuccess, onError, onCancel }) => {
  return <ClassicWizard Component={LoginButton} onSuccess={onSuccess} onError={onError} onCancel={onCancel} />;
};

function LoginButton({
  onSuccess,
  onError,
  onCancel,
}: {
  onSuccess: (response: ProviderAuthenticationIntentResponse) => void;
  onError: (error: unknown) => void;
  onCancel: () => void;
}) {
  const { isPending, mutate } = useStartProviderAuthIntent({
    mutationConfig: {
      onSuccess,
      onError,
    },
  });

  return (
    <>
      <Button
        className="w-full"
        disabled={isPending}
        onClick={() =>
          mutate(
            { data: { provider: 'mock', credentials: {} } },
            {
              onSuccess,
            },
          )
        }
      >
        {isPending && <Spinner />}
        Continue
      </Button>
      <CancelButton onCancel={onCancel} />
    </>
  );
}
